import { useGanttTip } from "@/shared/components/gantt-carga/hooks/use-gantt-tip";
import type { ObraLineMarkProps, ObraLineMarkViewModel } from "./types-gantt-obra-line";

/** Linhas cuja barra mede menos que isso mostram as datas ao lado, e não acima. */
const WIDE_LINE_REM = 6.5;

export function useObraLineMark({
  line,
  layout,
  widthRem,
}: ObraLineMarkProps): ObraLineMarkViewModel {
  const { anchorProps, tip } = useGanttTip(line.tooltip, line.card);

  return { line, layout, wide: widthRem >= WIDE_LINE_REM, anchorProps, tip };
}
